import AddCircleIcon from '@mui/icons-material/AddCircle';
import { ListItemIcon, ListItemText } from '@mui/material';
import FormattedMessage from 'features/i18n/FormattedMessage';
import { ReactNode } from 'react';
import styled from 'styled-components';

type CreateMenuItemContentProps = {
  messageId: string;
};

export const CreateMenuItemContent = ({ messageId }: CreateMenuItemContentProps) => {
  return (
    <>
      <StyledListItemIcon>
        <AddCircleIcon />
      </StyledListItemIcon>
      <ListItemText>
        <FormattedMessage id={messageId} />
      </ListItemText>
    </>
  );
};

const StyledListItemIcon = styled(ListItemIcon)`
  width: 24px;
`;
